import React, { useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import {ServiceResponse} from "../../../../../app/services/shared/interfaces";
import {AppContext} from "../../../../../contexts/AppContext";
import useReactConfirmAlert from "../../../../../hooks/useReactConfirmAlert";
import DefaultCard from "../../../../../components/default/DefaultCard";
import ButtonCreate from "../../../../../components/buttons/ButtonCreate";
import { EventParticipation, EventParticipationFilters } from '../../../../../app/models/EventParticipation';
import useEventParticipationService from '../../../../../app/services/intranet_company/hooks/useEventParticipantionService';
import EventParticipationDataTable from './tablas/EventParticipantionDataTable';

interface Props {
    eventId: number;
}

const EventParticipationContainer = ({ eventId }: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const {
        getEventParticipationsByEvent,
        fetchingGetEventParticipationsByEvent,
    } = useEventParticipationService();


    const [eventParticipations, setEventParticipations] = useState<EventParticipation[]>([]);
    const [totalRows, setTotalRows] = useState<number>(0);

    const [filter, setFilter] = useState<EventParticipationFilters>({
        page: 1,
        per_page: 10,
        sort: 'id',
        order: 'desc'
    });

    const [errorFields, setErrorFields] = useState<any>();

    useEffect(() => {
        reloadTable();
    }, [filter]);

    const reloadTable = () => {
        getEventParticipationsByEvent(eventId,filter, {
            onSuccess: (response: ServiceResponse) => {
                setEventParticipations(response.data.event_participations);
                setTotalRows(response.data.total_rows);
            },
            onError: (response: ServiceResponse) => {
                toast.error(response.message);
            }
        });
    };


    return (
        <>
            <DefaultCard>
                <div className="row">
                    <div className="col-12">
                        <EventParticipationDataTable
                            loading={fetchingGetEventParticipationsByEvent}
                            eventParticipations={eventParticipations}
                            totalRows={totalRows}
                            callbackSuccess={reloadTable}
                            filter={filter}
                            setFilter={setFilter}
                        />
                    </div>
                </div>
            </DefaultCard>

        </>
    );
};

export default EventParticipationContainer;
